import { render, staticRenderFns } from "./BindingWeixin.vue?vue&type=template&id=5a0730c2"
import script from "./BindingWeixin.vue?vue&type=script&lang=js"
export * from "./BindingWeixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports